import { Pagination } from "react-bootstrap";
import { Link } from "react-router-dom";

const Paginate = ({ pages, page, isAdmin = false, keyword = "", type }) => {
  if (pages <= 1) return null; // No pagination needed for single-page results

  return (
    <Pagination>
      {[...Array(pages).keys()].map((x) => (
        <Pagination.Item
          as={Link}
          key={x + 1}
          to={
            isAdmin
              ? `/admin/${type}/${x + 1}`
              : keyword
              ? `/search/${keyword}/page/${x + 1}`
              : `/page/${x + 1}`
          }
          active={x + 1 === page}
        >
          {x + 1}
        </Pagination.Item>
      ))}
    </Pagination>
  );
};

export default Paginate;